import React, { useState, useEffect } from "react";
import logo from "../logo.png";
import { NAV_ITEMS } from "../config/navItem";
import { useTheme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";
import style from "./style/headerStyle";
import UseAutoResponsive from "../hooks/UseAutoResponsive";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";

export default function Header() {
  const theme = useTheme();
  // We pass the theme to style function
  const headerStyles = style(theme);
  const { isMobile } = UseAutoResponsive();
  const [open, setOpen] = useState(false);

  // --- NEW: Scroll Detection Logic ---
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // If user scrolls down more than 50px, toggle state
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Dynamic Styles based on scroll
  const dynamicTextColor = isScrolled
    ? theme.palette.blue_prime
    : theme.palette.blue_prime;
  const dynamicBg = isScrolled ? "rgba(253, 249, 243, 0.5)" : "transparent";
  const dynamicShadow = isScrolled
    ? "0 8px 32px rgba(0, 0, 0, 0.05)"
    : "rgba(253, 249, 243, 0.5)";
  const dynamicBorder = isScrolled
    ? "1px solid rgba(255, 255, 255, 0.4)"
    : "none";

  return (
    <header style={headerStyles.headerWrapper}>
      {/* Announcement Bar */}
      <div
        style={{
          ...headerStyles.announcementBar,
          backgroundColor: theme.palette.prime,
        }}
      >
        ✨✨ Introducing Shaashwat - the heart of India ✨✨
      </div>

      {/* Navbar Container */}
      <div
        style={{
          ...headerStyles.navbar,
          background: dynamicBg,
          boxShadow: dynamicShadow,
          border: dynamicBorder,
        }}
      >
        <div style={headerStyles.logo}>
          <img
            src={logo}
            alt="Shaashwat Logo"
            width={90}
            height={55}
            style={{
              opacity: 0.85,
              objectFit: "contain",
              display: "block", // Fixes image alignment issues
            }}
          />
        </div>

        {!isMobile && (
          <nav style={headerStyles.navLinks}>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.label}
                to={item.path}
                style={({ isActive }) => ({
                  ...headerStyles.navItem,
                  // Dynamic Color: White at top, Blue when scrolled
                  color: isActive ? theme.palette.prime : dynamicTextColor,
                })}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        )}

        {isMobile && (
          <IconButton onClick={() => setOpen(true)} sx={{ p: 0.5 }}>
            {/* Icon also changes color */}
            <MenuIcon sx={{ color: dynamicTextColor, fontSize: 30 }} />
          </IconButton>
        )}
      </div>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <div style={headerStyles.mobileMenu}>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.label}
              to={item.path}
              onClick={() => setOpen(false)}
              style={({ isActive }) => ({
                ...headerStyles.mobileNavItem,
                color: isActive
                  ? theme.palette.prime
                  : theme.palette.blue_prime,
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </Drawer>
    </header>
  );
}
